<template>
    <div>
        <div class="IxKLjQtdla">
            <div :class="classObj">
                <div v-html="html"></div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'jabra-body-text-binding',
        props: {
            html: {
                type: String,
                default: ''
            },
            contentClass: {
                type: String,
                default: ''
            }
        },
        computed: {
            classObj() {
                return {
                    [this.contentClass]: true
                }
            }
        },
    }
</script>

<style lang="scss">
    .IxKLjQtdla {
        p {
            margin: 10px 0;
        }

        .dedication-subtitle {
            p {
                margin: 0;
            }
        }
    }

    /*@import "../../scss/main";*/


</style>
